// removed by extract-text-webpack-plugin
module.exports = {"spacing-large":"16px","this":"MessageStarter__this___6k5ae","body":"MessageStarter__body___2F6sW","scrollArea":"MessageStarter__scrollArea___2oqoG","loadingIndicatorContainer":"MessageStarter__loadingIndicatorContainer___1ljOs","highlightedItem":"MessageStarter__highlightedItem___1L61n","actionButton":"MessageStarter__actionButton___1Cibe Spacing__marginLeftMedium___1bHJc"};


//////////////////
// WEBPACK FOOTER
// ./src/chat/components/styles/MessageStarter.css
// module id = 1877
// module chunks = 4